((w, d) => {
    const wrapper = d.querySelector('.MainNav.no-js');
    wrapper.classList.remove('no-js');
    const nav = d.querySelector('.MainNav__expandable');
    const subbuttons = d.querySelectorAll('.MainNav__button');
    const mainitems = d.querySelectorAll('.MainNav__item');

    if (nav) {
        const navButton = d.querySelector('.MainNav__menu-button');
        if (navButton) {
            navButton.addEventListener('click', () => {
                const exp = navButton.getAttribute('aria-expanded') === 'false';
                navButton.setAttribute('aria-expanded', exp ? 'true' : 'false');
                nav.classList[exp ? 'add' : 'remove']('MainNav__expandable--active');
            });
        }
    }

    if (subbuttons) {
        subbuttons.forEach((button) => {
            button.setAttribute('aria-expanded', false);
            button.addEventListener('click', () => {
                const exp = button.getAttribute('aria-expanded');
                if (exp === 'false') {
                    button.setAttribute('aria-expanded', 'true');
                    button.parentElement.classList.add('MainNav__link-button--active');
                } else {
                    button.setAttribute('aria-expanded', 'false');
                    button.parentElement.classList.remove('MainNav__link-button--active');
                }
            });
        });
    }

    if (mainitems) {
        mainitems.forEach((item) => {
            const link = item.querySelector('.MainNav__link');
            // Hauptpunkte mit Untermenü haben keinen Link mehr (Toggle-Button); Escape regelt dort SubNavigation.js (tw_aurahotel)
            if (!link) {
                return;
            }
            item.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    link.focus();
                    item.classList.add('closed');
                }
            });
            link.addEventListener('focusout', () => {
                item.classList.remove('closed');
            });
        });
    }
})(window, document);
